export const Hero = ({content}) => { 
    return (
        <div className="m-auto text-3xl">
          <h1>
            {content}
          </h1>
            
        </div>
    )
}